import { Component, OnInit } from '@angular/core';
import { CardContent } from 'src/app/components/card/card.component';

@Component({
  selector: 'app-covidsim',
  templateUrl: './covidsim.component.html',
  styleUrls: ['./covidsim.component.scss']
})
export class CovidsimComponent implements OnInit {

  exposition: CardContent = {
    title: 'CovidSIM',
    subtitle: 'Pandemic preparedness planning for Covid-19',
    image_source: 'assets/images/CovidSIM-2.1.png',
    sections: [`
      <p>Kristan A. Schneider, Gideon A. Ngwa, Markus Schwehm, Linda Eichner, Martin Eichner: 
        <i>The COVID-19 pandemic preparedness simulation tool: CovidSIM.</i> 
        BMC Infectious Diseases Bd. 20, Article 859 (2020)</p>
      <p>Nick Wilson, Markus Schwehm, Ayesha J Verrall, Mathhew Parry, Michael G Baker, 
        Martin Eichner:
        <i>Detecting the re-emergent COVID-19 pandemic after elimination: modelling study 
          of combined primary care and hospital surveillance.</i>
        The New Zealand medical journal 133 (1524):28-39 (2020)</p>
      <p>Nick Wilson, Lucy Telfar Barnard, Amanda Kvalsvig, Ayesha Verrall, Michael Baker, 
        Markus Schwehm:
        <i>Modelling the Potential Health Impact of the COVID-19 Pandemic on a Hypothetical 
          European Country</i>
        (preprint 2020)</p>
      `]
  };

  information: CardContent = {
    title: 'Project Info',
    sections: [
      '<h4>Clients, Partners</h4>Epimos, University of Tübingen, LGA Stuttgart, BMBF',
      '<h4>Methods</h4>Deterministic Compartmental Modelling',
      '<h4>Technology / Skills</h4>Javascript, Angular, RK4',
      '<h4>Term</h4>2020-2021',
      '<h4>Explore the App</h4><a href="http://covidsim.de">covidsim.de</a>, <a href="http://covidsim.eu">covidsim.eu</a>'
    ]
  };


  constructor() { }

  ngOnInit(): void {
  }

}
